<template>
	<div class="uyh-learn-how">
		<p v-html="$t('learn_how_message')"></p>
		<router-link to="get-started">{{ $t('get_started') }}</router-link>
	</div>
</template>

<script>
  export default {
    mounted: function() {
			this.$emit('step-update', 'learn-how');
			this.$nextTick(function(){
        this.$emit('component-height');
      });
    }
  }
</script>

<style lang="scss" scoped>
	.responsivesite #wrapper #uyh-app,
  #uyh-app {
		.uyh-learn-how {
			margin: 0 auto;
			max-width: 500px;
			p {
				font-size: 20px;
				line-height: 1.3;
				padding: 69px 20px 0;
			}
			a {
				font-size: 20px;
				letter-spacing: 1px;
				line-height: normal;
				padding-top: 69px;
			}
		}
		@media screen and (max-width: 767px) {
			.uyh-learn-how {
				p {
					margin-bottom: 0;
					padding: 45px 20px 0;
				}
        a {
          padding-top: 45px;
        }
			}
		}
	}
</style>
